<template>
<v-row justify="center">
  <v-col cols="5">
    <v-dialog v-model="dialog" max-width="500px" persistent transition="dialog-transition" >
      <card-loading :loadingText="loadingText" :color='color'></card-loading>
    </v-dialog>
  </v-col>
</v-row>
</template>

<script>
  export default {
    name: 'DialogLoading',
    props: {
      loading: {
        type: Boolean,
        default: () => false
      },
      loadingText: {
        type: String,
        default: () => 'Carregando'
      },
      color: {
        type: String,
        default: () => 'primary'
      }
    },
    data() {
      return {
        dialog: true
      }
    },
  }
</script>

<style scoped>
.v-dialog {
  border-radius: 45px !important;
}

</style>